export const isUserAuthorized = (email) => {
    // Define Error Message
    let authorizedList = 'adam@tonenetworks.com,gemma@tonenetworks.com,pippa@tonenetworks.com,pippa.schwarzkopf@gmail.com,abdul.rehman@pk.ewsystemsinc.com'
    if (authorizedList.indexOf(email.toLowerCase()) >= 0) {
        console.info('authorized')
        return true
    } else {
        console.info('user not authorized')
        return false
    }
}



// WEBPACK FOOTER //
// ./src/authorizedUsersList.js